import styled from "styled-components";

export const Select = styled.select`
  margin-top: 2px;
  min-width: fit-content;
  width: -webkit-fill-available;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  text-transform: none;
  word-wrap: normal;
  display: block;
  padding: 4px 5px;
  font-weight: 400;
  line-height: 1.5;
  color: inherit;
  background-color: var(--main-color-i);
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  /* -webkit-appearance: none; */
  /* -moz-appearance: none; */
  /* appearance: none; */
`;
